<script setup lang="ts">
import { computed } from 'vue'

import { useActiveCity } from '~/composables/useActiveCity'

const runtimeConfig = useRuntimeConfig()
const activeCity = useActiveCity()

// Отзывы — из карточки организации своего города (cities.yandex_org_id): отзывы филиала не
// подменяются московскими. NUXT_PUBLIC_YANDEX_ORG_ID — запасной вариант. ID — только цифры:
// значение из CMS подставляется в адрес виджета.
const orgId = computed<string>(
  () =>
    (activeCity.value?.yandex_org_id ?? '').replace(/\D/g, '') ||
    String(runtimeConfig.public.yandexOrgId ?? '').replace(/\D/g, '')
)

const widgetUrl = computed(() => {
  return `https://yandex.ru/maps-reviews-widget/${orgId.value}?comments`
})
</script>

<template>
  <div class="h-full w-full overflow-hidden">
    <iframe
      :src="widgetUrl"
      title="Отзывы"
      class="border-brand-grey-light/30 h-full min-h-100 w-full rounded-xl border"
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade" />
  </div>
</template>
